import { render } from "./ShippingIcon.vue?vue&type=template&id=608c2042"
import script from "./ShippingIcon.vue?vue&type=script&lang=js"
export * from "./ShippingIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__